<template>
  <Dialog
    width="892px"
    titleAlign="left"
    :title="$$t('create.partial_regeneration')"
    :subTitle="$$t('create.partial_regeneration_subtitle')"
    :visible="renderData.visible"
    @close="closeDialog"
    mobileRenderType="drawerDialog"
  >
    <div
      class="height-all edit-regenerate-song flex-column"
      :class="{
        'edit-regenerate-song-mobile': createRenderType == 'mobile',
      }"
    >
      <div class="edit-extend-song-edit-box">
        <EditSelectSong
          v-if="renderData.ifRender"
          ref="refSelectSong"
          :duration="(props.item.duration_milliseconds ?? 0) / 1000"
          :url="`${getObjectStorageFullUrl(
            props.item.mp3_url
          )}?type=reEditSong`"
          @syncWaveLoadingState="doSyncWaveLoadingState"
        ></EditSelectSong>
      </div>
      <div class="edit-extend-song-done-btn-box">
        <div class="edit-extend-song-done-btn">
          <Button
            :disabled="renderData.isLoading || renderData.disabled"
            @click="doReGenerate"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '50px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--background':
                'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
              '--backgroundHover':
                'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.regenerate") }}
          </Button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import Dialog from "@/components/basic/dialog/Dialog.vue";
import Button from "@/components/basic/button/Button.vue";
import Record from "@/components/media/record/Record.vue";
import EditSelectSong from "@/page/create/editSong/editSelectSong.vue";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object,
    default: null,
  },
  pitem: {
    type: Object,
    default: null,
  },
});
const refSelectSong = ref(null);
const emits = defineEmits(["update:visible", "reGenerate", "close"]);
const renderData = reactive({
  visible: props.visible,
  isLoading: false,
  disabled: false,
  ifRender: true,
});

const doSyncWaveLoadingState = (loading) => {
  renderData.disabled = loading;
};

const closeDialog = () => {
  renderData.visible = false;
  emits("close", false);
};

const doReGenerate = () => {
  renderData.isLoading = true;
  emits(
    "reGenerate",
    {
      startTime: refSelectSong.value.getRenerateStartTime(),
    },
    () => {
      renderData.isLoading = false;
    }
  );
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);

const reRender = () => {
  renderData.ifRender = false;
  nextTick(() => {
    renderData.ifRender = true;
  });
};
const initResizeObserve = () => {
  renderData.resizeObserver = new ResizeObserver(() => {
    if (renderData.winWidth != window.innerWidth) {
      renderData.winWidth = window.innerWidth;
      reRender();
    }
  });
  renderData.resizeObserver?.observe(document.body);
};
onMounted(() => {
  renderData.winWidth = window.innerWidth;
  initResizeObserve();
});
onUnmounted(() => {
  renderData.resizeObserver?.disconnect();
});
</script>
<style lang="scss" scope>
.edit-regenerate-song {
  margin: 15px 40px 40px 40px;
  .edit-extend-song-done-btn-box {
    padding: 0 32px;
    .edit-extend-song-done-btn {
      margin: 60px auto 0 auto;
      max-width: 400px;
    }
  }
  &.edit-regenerate-song-mobile {
    margin: 15px 16px 16px 16px;
    .edit-extend-song-done-btn-box{
      padding: 0;
    }
    .edit-extend-song-done-btn {
      margin: 28px auto 12px auto;
      max-width: 100%;
      width: 100%;
    }
  }
}
</style>
